import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Form, Input, Select } from "antd";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    width: 90%;
  }
`;

const RowContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

const FormBox = styled.div`
  margin-bottom: 10px;
  width: 100%;
`;

const DisabledInput = styled(Input)`
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.85);
  cursor: not-allowed;
  width: 100%;
  font-size: 14px;
  color: #9c9c9c;
`;

type AccountDetailsProps = {
  vendor: any;
};

const accountDetails: React.FC<AccountDetailsProps> = ({ vendor }) => {
  // Combine country, state, and city into a single location string
  const getLocationString = () => {
    const parts = [];
    if (vendor?.city) parts.push(vendor.city);
    if (vendor?.state) parts.push(vendor.state);
    if (vendor?.country) parts.push(vendor.country);

    return parts.length > 0 ? parts.join(", ") : "Not provided";
  };

  return (
    <Container>
      <Form layout="vertical">
        <FormBox>
          <Form.Item label="Business Name">
            <DisabledInput value={vendor?.businessName || "Not provided"} disabled style={{ paddingLeft: "0.5rem" }} />
          </Form.Item>
        </FormBox>

        <FormBox>
          <Form.Item label="Business Category">
            <DisabledInput
              value={vendor?.businessCategoryName || "Not provided"}
              disabled
              style={{ paddingLeft: "0.5rem" }}
            />
          </Form.Item>
        </FormBox>

        <FormBox>
          <Form.Item label="Business Description">
            <Input.TextArea
              value={vendor?.description || "Not provided"}
              disabled
              autoSize={{ minRows: 3, maxRows: 6 }}
              style={{ paddingLeft: "0.5rem" }}
            />
          </Form.Item>
        </FormBox>
        <FormBox>
          <Form.Item label="Location">
            <DisabledInput value={getLocationString()} disabled style={{ paddingLeft: "0.5rem" }} />
          </Form.Item>
        </FormBox>
        <RowContainer>
          <FormBox style={{ flex: 1 }}>
            <Form.Item label="First Name">
              <DisabledInput value={vendor?.user?.firstName} disabled style={{ paddingLeft: "0.5rem" }} />
            </Form.Item>
          </FormBox>
          <FormBox style={{ flex: 1 }}>
            <Form.Item label="Last Name">
              <DisabledInput value={vendor?.user?.lastName} disabled style={{ paddingLeft: "0.5rem" }} />
            </Form.Item>
          </FormBox>
        </RowContainer>
        <FormBox>
          <Form.Item label="Email Address">
            <DisabledInput value={vendor?.vendorEmail} disabled style={{ paddingLeft: "0.5rem" }} />
          </Form.Item>
        </FormBox>
        <FormBox>
          <Form.Item label="Phone Number">
            <DisabledInput value={vendor?.user?.phone || "Not provided"} disabled style={{ paddingLeft: "0.5rem" }} />
          </Form.Item>
        </FormBox>
      </Form>
    </Container>
  );
};

export default accountDetails;
